import { AxiosRequestConfig, AxiosResponse } from 'axios'
import HttpClient from '../http-client'
import { httpConfig } from '../constants'
import { Run } from '../model/models'
import { ETRLKPI } from '../model'

export class ETRLAPI extends HttpClient {
  public constructor(apiConfig: AxiosRequestConfig) {
    super(apiConfig)
    this.getRunsForETRLKpis = this.getRunsForETRLKpis.bind(this)
  }

  public getRunsForETRLKpis(): Promise<any> {
    const endpoint = '/etrl-kpi-runs'
    return this.get<Run[]>(endpoint)
      .then((response: AxiosResponse<Run[]>) =>
        response.data.map((r) => ({
          id: r.id,
          runAt: new Date(r.runAt),
        })),
      )
      .catch((error) => {
        throw error
      })
  }

  public getKPIsForCurrentRun(runId: number): Promise<any> {
    const endpoint = `/etrl-kpi-results/${runId}`
    return this.get<ETRLKPI[]>(endpoint)
      .then((response: AxiosResponse<ETRLKPI[]>) => response.data)
      .catch((error) => {
        throw error
      })
  }
}

export const etrlAPI = new ETRLAPI(httpConfig)
